import { makeActionCreator } from '../../config/store/utils'
import { getSectorPurchasingMechanisms } from '../../services/sectors'

export const GET_SECTOR_PURCHASING_MECHANISMS = 'GET_SECTOR_PURCHASING_MECHANISMS'
export const GET_SECTOR_PURCHASING_MECHANISMS_ERROR = 'GET_SECTOR_PURCHASING_MECHANISMS_ERROR'
export const GET_SECTOR_PURCHASING_MECHANISMS_SUCCESS = 'GET_SECTOR_PURCHASING_MECHANISMS_SUCCESS'
export const onGetSectorPurchasingMechanisms = makeActionCreator(GET_SECTOR_PURCHASING_MECHANISMS)
export const onGetSectorPurchasingMechanismsError = makeActionCreator(GET_SECTOR_PURCHASING_MECHANISMS_ERROR, 'payload')
export const onGetSectorPurchasingMechanismsSuccess = makeActionCreator(
  GET_SECTOR_PURCHASING_MECHANISMS_SUCCESS,
  'payload'
)
export const onGetSectorPurchasingMechanismsThunk = payload => async dispatch => {
  dispatch(onGetSectorPurchasingMechanisms())

  try {
    const { data = {} } = await getSectorPurchasingMechanisms({ sectorId: payload.id, year: payload.year })
    const enhancedData = data.payload?.map(datum => ({
      amount: datum.amountAccumulatedCLP,
      amountUSD: datum.amountAccumulatedUSD,
      name: datum.modality,
      orders: datum.quantityAccumulatedOC,
      percentage: datum.percentage
    }))
    const categories = enhancedData.map(datum => datum.name)
    const csv = [
      ['Mecanismo de compra', 'Nº de órdenes de compra', 'Monto total', 'Monto total (USD)'],
      ...enhancedData.map(datum => [datum.name, datum.orders, datum.amount, datum.amountUSD])
    ]

    return dispatch(onGetSectorPurchasingMechanismsSuccess({ categories, csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetSectorPurchasingMechanismsError({ error }))
  }
}
